import FormattedMessage from 'I18n/components/FormattedMessage';
import { useConfigs } from './lib/config-context';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const MaxCardsAlert = () => {
  const {
    maxCardsPerColumn
  } = useConfigs();
  return /*#__PURE__*/_jsx(Alert, {
    margin: "400",
    type: "info",
    use: "inline",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customer-data-board.cardLimitReachedAlert",
      options: {
        count: maxCardsPerColumn
      },
      "data-test-id": "cdb-column-items-show-more-limit"
    })
  });
};
export default MaxCardsAlert;